import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'Telling a Hard Truth',
  slug: 'telling-a-hard-truth',
  category: 'Telling a hard truth',
  date: '2025-05-16',
  image: '',
  excerpt: 'Check yourself before telling someone a hard truth.',
  body: `Check yourself before telling someone a hard truth.

Some questions you might ask yourself if you want to tell somebody something they might not want to hear:

- Is it true? If yes, proceed…
- Does this person need to hear it? If yes, proceed…
- Does this person need to hear it now? If yes, proceed…
- Does this person need to hear it from you? If yes, proceed…
- Is it kind?

An honest assessment might avoid some hurt feelings.`,
}

export default post
